import styled from "styled-components";

export const Hero = styled.div<{ image: string; height?: string }>`
    margin-top: 1rem;
    height: ${({ height }) => height || "35rem"};
    border-radius: 5rem 0;
    background-image: ${({ image }) => `url("${image}")`};
    background-size: cover;
    display: grid;
    align-content: center;
    background-position: center;
`;
